import React, { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { noop } from 'ui-components/default-props/noop';

import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';
import { SHIPMENT } from '../../../../constants/fulfillment-types';
import { DocumentType } from '../../../../enums/document-type';
import { FulfillmentPropType } from '../../../../prop-types/fulfillment';
import { PrintDocumentButtonHelperService } from '../../../../services/print-document-button-container-helper-service';
import { printLabel } from '../../../../store/printing/print.actions';
import { useLabelDefaultPrintSettings } from '../hooks/use-label-default-print-settings';

export const Label = ({ fulfillments, userHasShippingRole, onClick: onClickProp = noop }) => {
  const dispatch = useDispatch();

  const isDisabled = useMemo(() => {
    if (!userHasShippingRole) {
      return true;
    }

    const nonVoidedFulfillments = fulfillments.filter((f) => !f.isLabelVoided);
    const printableLabelFulfillments = nonVoidedFulfillments.filter((f) => f.fulfillmentType?.toLowerCase?.() === SHIPMENT.toLowerCase());
    return printableLabelFulfillments.length === 0;
  }, [fulfillments, userHasShippingRole]);

  const { activeFulfillmentIds, fulfillmentPlanIdsWithLabel, hasPrintedLabel } =
    PrintDocumentButtonHelperService.getPrintModalData(fulfillments);

  const onClick = useCallback(() => {
    dispatch(printLabel(fulfillmentPlanIdsWithLabel, activeFulfillmentIds, hasPrintedLabel, false, false));
    onClickProp();
  }, [activeFulfillmentIds, dispatch, fulfillmentPlanIdsWithLabel, hasPrintedLabel, onClickProp]);

  const defaultPrintSetting = useLabelDefaultPrintSettings(activeFulfillmentIds, hasPrintedLabel);

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.Label.documentNameTranslation}
      onClick={onClick}
    />
  );
};

Label.propTypes = {
  fulfillments: PropTypes.arrayOf(FulfillmentPropType).isRequired,
  userHasShippingRole: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};
